/**
 * Affiche, sous une question, l'erreur renvoyée par le CRM lors de l'envoi.
 *
 * Distinct des erreurs de saisie habituelles : celles-ci ne viennent pas du
 * navigateur mais de Salesforce, qui a refusé la valeur au moment de l'envoi.
 * Elles persistent jusqu'à ce que le candidat modifie la réponse.
 *
 * Reprend le style `field-error` déjà employé par Question_Text.
 */

export default function SalesforceFieldError({ error }) {
  if (!error) return null;

  const fixable = error.fixable !== false;

  return (
    <div
      className="field-error salesforce-error"
      role="alert"
      aria-live="assertive"
      style={{
        color: fixable ? '#b30000' : '#8a4b00',
        background: fixable ? '#ffeaea' : '#fff4e5',
        border: `1px solid ${fixable ? '#e0a0a0' : '#e0c090'}`,
        borderRadius: '4px',
        fontSize: '0.9rem',
        marginTop: '6px',
        padding: '8px 10px'
      }}
    >
      <strong>{fixable ? 'À corriger : ' : 'Information : '}</strong>
      {error.message}

      {/* Rappelle la valeur refusée : sans elle, le candidat ne comprend pas
          toujours ce qui pose problème dans sa réponse. */}
      {error.value ? (
        <div style={{ marginTop: '4px', fontStyle: 'italic' }}>
          Valeur envoyée : « {String(error.value)} »
        </div>
      ) : null}
    </div>
  );
}
